import React, {useRef} from "react"
import PageBanner from "../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap"
import aboutImg from "../../../../assets/website-images/about/about.png"
import "./about.scss"
import {motion, useInView} from "framer-motion";
import missionImg from "../../../../assets/website-images/about/mission.png"
import aboutPageImg from "../../../../assets/website-images/about/about-banner.png"
import aboutBannerImg from "../../../../assets/website-images/about/about-banner-b.jpg"
import {useTranslation} from "react-i18next";

export default function About() {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const {t} = useTranslation();
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };
    return(
        <div className={'about'}>
            <PageBanner img={aboutPageImg} heading={t('about.banner_head')} bannerImg={aboutBannerImg}/>
            <div className={'home-about'}>
                <Container>
                    <Row>
                        <Col md={12} lg={7} className={'d-flex align-items-center'}>
                            <div className={'heading-section'}  ref={ref}>
                                <motion.h4
                                    className={'subheading'}
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                >
                                    {t('about.section1_sub')}
                                </motion.h4>
                                <motion.h2
                                    className={'heading'}
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                >
                                    {t('about.section1_head')}
                                </motion.h2>
                                <motion.p
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                    className='para'
                                >
                                    {t('about.section1_para1')}
                                </motion.p>
                                <motion.p
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                    className='para'
                                >
                                    {t('about.section1_para2')}
                                </motion.p>
                                <motion.p
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                    className='para'
                                >
                                    {t('about.section1_para3')}
                                </motion.p>

                            </div>
                        </Col>
                        <Col className={'d-flex align-items-center'} md={12} lg={5}>
                            <img src={aboutImg} className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/*<div className={'about-boxes'}>*/}
            {/*    <Container>*/}
            {/*        <motion.div className="cards"*/}
            {/*                    variants={containerVariants2}*/}
            {/*                    initial="hidden"*/}
            {/*                    animate={isInView ? "show" : "hidden"}*/}
            {/*                    ref={ref}*/}
            {/*        >*/}
            {/*            <Row>*/}
            {/*                <Col md={12} lg={4}>*/}
            {/*                    <motion.div className="about-card" variants={cardVariants}>*/}
            {/*                        <span><AboutIcon1/></span>*/}
            {/*                        <h4>Empathy</h4>*/}
            {/*                        <p>We understand the human side of the technology.</p>*/}
            {/*                    </motion.div>*/}
            {/*                </Col>*/}
            {/*                <Col md={12} lg={4}>*/}
            {/*                    <motion.div className="about-card" variants={cardVariants}>*/}
            {/*                        <span><AboutIcon2/></span>*/}
            {/*                        <h4>Morality</h4>*/}
            {/*                        <p>We prioritize ethics in every decision we make.</p>*/}
            {/*                    </motion.div>*/}
            {/*                </Col>*/}
            {/*                <Col md={12} lg={4}>*/}
            {/*                    <motion.div className="about-card mb-0" variants={cardVariants}>*/}
            {/*                       <span><AboutIcon3/></span>*/}
            {/*                        <h4>Agile</h4>*/}
            {/*                        <p>We adapt and innovate swiftly in a dynamic tech landscape.</p>*/}
            {/*                    </motion.div>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*        </motion.div>*/}
            {/*    </Container>*/}
            {/*</div>*/}

            <div className={'about-mission'}>
                <Container>
                    <Row className={'justify-content-between'}>
                        <Col md={12} xl={8}>
                            <div className={'mission-section'}>
                                <div className={'mission-box'}>
                                    <div className={'head'}>
                                        <h2 className={'heading'}> {t('about.mission_head')}</h2>
                                    </div>
                                    <div className={'content'}>
                                        <h4>  {t('about.mission_text')}</h4>
                                        <p className={'mb-3'}> {t('about.mission_para1')}</p>
                                        <p> {t('about.mission_para2')}</p>
                                    </div>
                                </div>
                                <div className={'mission-box'}>
                                    <div className={'head'}>
                                        <h2 className={'heading'}> {t('about.vision_head')}</h2>
                                    </div>
                                    <div className={'content'}>
                                        <h4>  {t('about.vision_text')}</h4>
                                        <p className={'mb-3'}> {t('about.vision_para1')}</p>
                                        <p> {t('about.vision_para2')}</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={12} xl={4} className={'text-center d-none d-xl-block'}>
                            <img src={missionImg} className={'img-fluid mt-5'}/>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/*<div className={'about-values'}>*/}
            {/*    <Container>*/}
            {/*        <Row>*/}
            {/*            <Col md={12}>*/}
            {/*                <div className={'heading-section'}>*/}
            {/*                    <h4 className={'subheading'}>Core Values</h4>*/}
            {/*                    <h2 className={'heading'}>Commitment to Quality and Innovation</h2>*/}
            {/*                </div>*/}
            {/*            </Col>*/}
            {/*            <Col md={12}>*/}
            {/*                <div className={'value-list-section'}>*/}
            {/*                    <ul>*/}
            {/*                        <li>*/}
            {/*                            <h4>Partnership</h4>*/}
            {/*                            <p>We make sure that any work effort is driven by a strong sense of team spirit and partnership with an aim to build strong ties with our business partners and stakeholders.</p>*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            <h4>Quality</h4>*/}
            {/*                            <p>We make sure that any work effort is driven by a strong sense of team spirit and partnership with an aim to build strong ties with our business partners and stakeholders.</p>*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            <h4>Commitment</h4>*/}
            {/*                            <p>We make sure that any work effort is driven by a strong sense of team spirit and partnership with an aim to build strong ties with our business partners and stakeholders.</p>*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            <h4>Reliability</h4>*/}
            {/*                            <p>We make sure that any work effort is driven by a strong sense of team spirit and partnership with an aim to build strong ties with our business partners and stakeholders.</p>*/}
            {/*                        </li>*/}
            {/*                    </ul>*/}
            {/*                </div>*/}
            {/*            </Col>*/}
            {/*        </Row>*/}
            {/*    </Container>*/}
            {/*</div>*/}
        </div>
    )
}